<template>
  <el-form
    :model="editForm"
    ref="editForm"
    :rules="rules"
    label-width="110px"
    :hide-required-asterisk="false"
  >
    <el-row>
      <el-col :span="14">
        <el-row>
          <el-col style="margin: 15px 0">
            <el-steps :active="editForm.jdTime.length" align-center>
              <el-step
                :title="item.status"
                :description="item.times"
                v-for="(item, index) in editForm.jdTime"
                :key="index"
              ></el-step>
            </el-steps>
          </el-col>
          <el-col :span="24">
            <el-tabs v-model="activeEditor" @tab-click="handleClickTabs">
              <el-tab-pane label="详细描述" name="0">
                <!-- <span><div id="wangEditor_view"></div></span> -->
                <div class="content_view">
                  <span
                    v-for="(picItem, picIndex) in editForm.detailSlice"
                    :key="picIndex"
                  >
                    <span v-if="picItem && picItem.picBig">
                      <span>
                        <el-image
                          :src="picItem.srcBig"
                          :preview-src-list="[picItem.srcBig]"
                        >
                        </el-image>
                      </span>
                    </span>
                    <span v-else v-html="picItem"></span>
                  </span>
                </div>
              </el-tab-pane>
              <el-tab-pane label="解决方案" name="1">
                <div class="content_view">
                  <span
                    v-for="(picItem, picIndex) in editForm.jjfaSlice"
                    :key="picIndex"
                  >
                    <span v-if="picItem && picItem.picBig">
                      <span>
                        <el-image
                          :src="picItem.srcBig"
                          :preview-src-list="[picItem.srcBig]"
                        >
                        </el-image>
                      </span>
                    </span>
                    <span v-else v-html="picItem"></span>
                  </span>
                </div>
              </el-tab-pane>
              <el-tab-pane label="变更历史" name="2">
                <el-table
                  :data="editForm.history"
                  fit
                  highlight-current-row
                  :default-sort="{ prop: 'date', order: 'descending' }"
                  tooltip-effect="dark"
                >
                  <el-table-column
                    label="序号"
                    align="left"
                    prop="id"
                    min-width="80px"
                    :show-overflow-tooltip="true"
                  />
                  <el-table-column
                    label="变更时间"
                    align="left"
                    prop="updatetime"
                    min-width="120px"
                    :show-overflow-tooltip="true"
                  />

                  <el-table-column
                    label="变更人"
                    align="left"
                    prop="updateby"
                    min-width="80px"
                    :show-overflow-tooltip="true"
                  />
                  <el-table-column
                    label="变更字段"
                    align="left"
                    prop="attribute"
                    min-width="150px"
                    :show-overflow-tooltip="true"
                  />
                  <el-table-column
                    label="变更前"
                    align="left"
                    prop="oldvalue"
                    min-width="120px"
                    :show-overflow-tooltip="true"
                  >
                    <!-- <template slot-scope="scope">
                     <div v-html="scope.row.oldvalue"></div>
                    </template> -->
                  </el-table-column>
                  <el-table-column
                    label="变更后"
                    align="left"
                    prop="newvalue"
                    min-width="120px"
                    :show-overflow-tooltip="true"
                  >
                    <!-- <template slot-scope="scope">
                     <div v-html="scope.row.newvalue"></div>
                    </template> -->
                  </el-table-column>
                  <template slot="empty">
                    <div class="nodata">
                      <img src="@/img/nodata.png" alt="" width="160" />
                      <div>暂无数据</div>
                    </div>
                  </template>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </el-col>
          <div v-show="activeEditor != '2'">
            <el-col style="line-height: 40px; font-weight: 700; font-size: 16px"
              >附件</el-col
            >
            <el-col :span="24" style="margin-top: 15px"> </el-col>
            <el-col :span="24">
              <!-- <el-form-item label="openPreview"> -->
              <el-table
                :data="editForm.file"
                fit
                highlight-current-row
                :default-sort="{ prop: 'date', order: 'descending' }"
                tooltip-effect="dark"
              >
                <el-table-column
                  label="文件名称"
                  align="left"
                  prop="name"
                  min-width="220px"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <el-link @click="openPreview(scope.row)" type="primary">{{
                      scope.row.name
                    }}</el-link>
                  </template>
                </el-table-column>
                <el-table-column
                  label="上传时间"
                  align="left"
                  prop="uploadtime"
                  min-width="200px"
                  :show-overflow-tooltip="true"
                />

                <el-table-column
                  label="上传阶段"
                  align="left"
                  prop="up"
                  min-width="200px"
                  :show-overflow-tooltip="true"
                />

                <el-table-column
                  label="操作"
                  align="left"
                  min-width="100px"
                  :show-overflow-tooltip="true"
                  fixed
                >
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="handleDownloadFile(scope.row)"
                      >下载</el-button
                    >
                  </template>
                </el-table-column>
                <template slot="empty">
                  <div class="nodata">
                    <img src="@/img/nodata.png" alt="" width="160" />
                    <div>暂无数据</div>
                  </div>
                </template>
              </el-table>
              <!-- </el-form-item> -->
            </el-col>
            <el-col
              style="
                line-height: 40px;
                display: flex;
                margin: 15px 0;
                justify-content: space-between;
              "
            >
              <div>
                <span style="font-weight: 700; font-size: 16px">评论</span> 共{{
                  editForm.pinglun.length
                }}条评论
              </div>
              <el-button type="primary" @click="handleAddComment"
                >评论</el-button
              >
            </el-col>
            <el-col :span="24">
              <span><div id="wangEditor3_view"></div></span>
            </el-col>
            <el-col>
              <div
                v-for="item in editForm.pinglun"
                :key="item.id"
                class="zpsm-comment-item"
              >
                <div class="top">
                  <div>{{ item.username ? item.username[0] : "" }}</div>
                  <div>{{ item.username }}</div>
                </div>
                <div class="middle">
                  <!-- <span v-html="item.content"></span> -->
                  <div>
                    <span
                      v-for="(picItem, picIndex) in item.commnetSlice"
                      :key="picIndex"
                    >
                      <span v-if="picItem && picItem.picBig">
                        <span>
                          <el-image
                            style="max-width: 200px"
                            :src="picItem.srcBig"
                            :preview-src-list="[picItem.srcBig]"
                          >
                          </el-image>
                        </span>
                      </span>
                      <span v-else v-html="picItem"></span>
                    </span>
                  </div>
                </div>
                <div class="bottom">
                  {{ item.createtime }}
                </div>
              </div>
            </el-col>
          </div>
        </el-row>
      </el-col>
      <el-col :span="10">
        <div class="r">
          <el-tabs v-model="activeRight" @tab-click="handleClickTabsRight">
            <el-tab-pane label="基本信息" name="0">
              <div class="r_form">
                <el-row>
                  <el-col :span="24">
                    <el-form-item
                      label="现指派给"
                      prop="designee"
                      v-if="editForm.status != 5"
                    >
                      <treeselect
                        v-model="editForm.designee"
                        placeholder="请选择员工"
                        :options="deptUser"
                        :disable-branch-nodes="true"
                        :show-count="true"
                        value-consists-of="LEAF_PRIORITY"
                        no-results-text="未搜到任何结果"
                        :clear-on-select="true"
                        :normalizer="normalizer"
                        style="width: 100%"
                        size="small"
                        disabled
                      />
                    </el-form-item>
                    <el-form-item label="现指派给" prop="designee" v-else>
                      <el-input
                        placeholder="请输入内容"
                        value="Closed"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="指派说明" prop="designee">
                      <el-input
                        placeholder="请输入内容"
                        v-model="editForm.content"
                        disabled
                      >
                        <template slot="append"
                          ><div @click="zpsmDialog = true" style="">
                            更多
                          </div></template
                        >
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="当前状态" prop="designee">
                      <el-select
                        v-model="editForm.status"
                        filterable
                        default-first-option
                        style="width: 100%"
                        placeholder="请选择当前状态"
                        disabled
                      >
                        <el-option
                          v-for="item in statusList"
                          :key="item.dictValue"
                          :label="item.dictLabel"
                          :value="item.dictValue"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="问题分类" prop="designee">
                      <el-select
                        v-model="editForm.sort"
                        filterable
                        default-first-option
                        style="width: 100%"
                        placeholder="请选择问题分类"
                        disabled
                      >
                        <el-option
                          v-for="item in sortList"
                          :key="item.dictValue"
                          :label="item.dictLabel"
                          :value="item.dictValue"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <el-col>
                    <el-form-item label="所属条线" prop="designee">
                      <el-select
                        v-model="editForm.line"
                        filterable
                        default-first-option
                        style="width: 100%"
                        placeholder="请选择所属条线"
                        disabled
                      >
                        <el-option
                          v-for="item in txList"
                          :key="item.dictValue"
                          :label="item.dictLabel"
                          :value="item.dictValue"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="所属项目" prop="designee">
                      <el-select
                        v-model="editForm.xmbh"
                        filterable
                        default-first-option
                        style="width: 100%"
                        placeholder="请选择所属项目"
                        disabled
                      >
                        <el-option
                          v-for="item in xmList"
                          :key="item.xmbh"
                          :label="item.xmjc"
                          :value="item.xmbh"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="产品版本" prop="productVersion">
                      <el-input
                        show-word-limit
                        placeholder=""
                        v-model="editForm.productVersion"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="所属模块" prop="module">
                      <el-input
                        show-word-limit
                        placeholder=""
                        v-model="editForm.module"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="影响版本" prop="influenceVersion">
                      <el-input
                        show-word-limit
                        placeholder=""
                        v-model="editForm.influenceVersion"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="由谁创建" prop="createBy">
                      <treeselect
                        v-model="editForm.creator"
                        placeholder="请选择员工"
                        :options="deptUser"
                        :disable-branch-nodes="true"
                        :show-count="true"
                        value-consists-of="LEAF_PRIORITY"
                        no-results-text="未搜到任何结果"
                        :clear-on-select="true"
                        :normalizer="normalizer"
                        style="width: 100%"
                        size="small"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="创建时间" prop="createTime">
                      <el-input
                        show-word-limit
                        placeholder=""
                        v-model="editForm.createTime"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="处理结果" prop="progress">
                      <el-input
                        show-word-limit
                        placeholder=""
                        v-model="editForm.progress"
                        disabled
                      >
                        <template slot="append"
                          ><div>%</div></template
                        ></el-input
                      >
                    </el-form-item>
                  </el-col>

                  <el-col>
                    <el-form-item label="期望完成时间" prop="finishTime">
                      <el-date-picker
                        type="date"
                        placeholder="选择日期"
                        v-model="editForm.finishTime"
                        :picker-options="pickerOptions"
                        style="width: 100%"
                        disabled
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="上线时间" prop="sxsj">
                      <el-date-picker
                        type="date"
                        placeholder="选择日期"
                        v-model="editForm.sxsj"
                        style="width: 100%"
                        :clearable="false"
                        disabled
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="计划工时(天)" prop="planTime">
                      <el-input-number
                        :min="0"
                        label="描述文字"
                        v-model="editForm.planTime"
                        style="width: 100%"
                        disabled
                      >
                      </el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <div class="r_more_btn" @click="rFromMoreFlag = !rFromMoreFlag">
                <span v-if="rFromMoreFlag"
                  >收起<i class="el-icon-arrow-up"></i
                ></span>
                <span v-else> 更多<i class="el-icon-arrow-down"></i></span>
              </div>
              <div class="r_form_more" v-show="rFromMoreFlag">
                <el-row>
                  <el-col>
                    <el-form-item label="实际工时" prop="realWorkload">
                      <el-input-number
                        :min="0"
                        label="描述文字"
                        v-model="editForm.realWorkload"
                        style="width: 100%"
                        disabled
                      >
                      </el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="截止时间" prop="endtime">
                      <el-input
                        show-word-limit
                        placeholder=""
                        v-model="editForm.endtime"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="严重程度" prop="questionLevelName">
                      <el-select
                        v-model="editForm.questionLevelName"
                        filterable
                        default-first-option
                        style="width: 100%"
                        placeholder=""
                        disabled
                      >
                        <el-option
                          v-for="item in txList"
                          :key="item.dictValue"
                          :label="item.dictLabel"
                          :value="item.dictValue"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="由谁确认" prop="confirmer">
                      <treeselect
                        v-model="editForm.confirmer"
                        placeholder="请选择员工"
                        :options="deptUser"
                        :disable-branch-nodes="true"
                        :show-count="true"
                        value-consists-of="LEAF_PRIORITY"
                        no-results-text="未搜到任何结果"
                        :clear-on-select="true"
                        :normalizer="normalizer"
                        style="width: 100%"
                        size="small"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="由谁解决" prop="confirmer">
                      <treeselect
                        v-model="editForm.confirmer"
                        placeholder="请选择员工"
                        :options="deptUser"
                        :disable-branch-nodes="true"
                        :show-count="true"
                        value-consists-of="LEAF_PRIORITY"
                        no-results-text="未搜到任何结果"
                        :clear-on-select="true"
                        :normalizer="normalizer"
                        style="width: 100%"
                        size="small"
                        disabled
                      />
                    </el-form-item>
                  </el-col>

                  <el-col :span="24">
                    <el-form-item label="由谁验证" prop="verifier">
                      <treeselect
                        v-model="editForm.verifier"
                        placeholder="请选择员工"
                        :options="deptUser"
                        :disable-branch-nodes="true"
                        :show-count="true"
                        value-consists-of="LEAF_PRIORITY"
                        no-results-text="未搜到任何结果"
                        :clear-on-select="true"
                        :normalizer="normalizer"
                        style="width: 100%"
                        size="small"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="由谁关闭" prop="closer">
                      <treeselect
                        v-model="editForm.closer"
                        placeholder="请选择员工"
                        :options="deptUser"
                        :disable-branch-nodes="true"
                        :show-count="true"
                        value-consists-of="LEAF_PRIORITY"
                        no-results-text="未搜到任何结果"
                        :clear-on-select="true"
                        :normalizer="normalizer"
                        style="width: 100%"
                        size="small"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="由谁重新打开" prop="opener">
                      <treeselect
                        v-model="editForm.opener"
                        placeholder="请选择员工"
                        :options="deptUser"
                        :disable-branch-nodes="true"
                        :show-count="true"
                        value-consists-of="LEAF_PRIORITY"
                        no-results-text="未搜到任何结果"
                        :clear-on-select="true"
                        :normalizer="normalizer"
                        style="width: 100%"
                        size="small"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="打开次数" prop="openTimes">
                      <el-input
                        show-word-limit
                        placeholder="如：V1.6.3"
                        v-model="editForm.openTimes"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="由谁重新激活" prop="activatedBy">
                      <treeselect
                        v-model="editForm.activatedBy"
                        placeholder="请选择员工"
                        :options="deptUser"
                        :disable-branch-nodes="true"
                        :show-count="true"
                        value-consists-of="LEAF_PRIORITY"
                        no-results-text="未搜到任何结果"
                        :clear-on-select="true"
                        :normalizer="normalizer"
                        style="width: 100%"
                        size="small"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="激活次数" prop="activateTimes">
                      <el-input
                        show-word-limit
                        placeholder=""
                        v-model="editForm.activateTimes"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-tab-pane>
            <el-tab-pane label="查看审核" name="1">
              <div
                class="r_review"
                v-if="
                  editForm.reviewedDetail && editForm.reviewedDetail.length > 0
                "
              >
                <div
                  v-for="(item, index) of editForm.reviewedDetail"
                  :key="index"
                >
                  <div class="tips">{{ item.no }}</div>
                  <div
                    class="r_review_item"
                    v-for="(item2, index2) of item.reviewed"
                    :key="index2"
                  >
                    <div class="top">
                      <div>{{ item2.xm[0] }}</div>
                      <div>{{ item2.xm }}</div>
                      <div>{{ item.designee }}</div>
                    </div>
                    <div class="middle" v-html="item2.bz"></div>
                    <div class="bottom">
                      {{ item2.updatetime }}
                    </div>
                    <div class="r_review_status">
                      <img
                        src="@/img/tongguo.png"
                        alt=""
                        v-if="item2.status == '通过'"
                      />
                      <img
                        src="@/img/bohui.png"
                        alt=""
                        v-else-if="item2.status == '不通过'"
                      />

                      <img src="@/img/dsh.svg" alt="" v-else />
                    </div>
                  </div>
                </div>
              </div>
              <div v-else style="text-align: center">
                <div><img src="@/img/nodata.png" alt="" width="240" /></div>
                <div style="color: #bfbfbf; font-size: 16px">暂无审核</div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="查看上线" name="2">
              <div class="r_online" v-show="editForm.onlineDetail.qdqrfzr">
                <el-row>
                  <el-col>
                    <el-form-item label="项目" prop="">
                      <el-input
                        show-word-limit
                        placeholder=""
                        v-model="editForm.xmmc"
                        disabled
                        size=""
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="清单确认负责人" prop="">
                      <treeselect
                        v-model="editForm.onlineDetail.qdqrfzr"
                        placeholder="请选择员工"
                        :options="deptUser"
                        :disable-branch-nodes="true"
                        :show-count="true"
                        value-consists-of="LEAF_PRIORITY"
                        no-results-text="未搜到任何结果"
                        :clear-on-select="true"
                        :normalizer="normalizer"
                        style="width: 100%"
                        size="small"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="清单确认日期" prop="">
                      <el-input
                        show-word-limit
                        placeholder=""
                        v-model="editForm.onlineDetail.qdqrrq"
                        disabled
                        size=""
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <div style="margin-bottom: 15px">需求描述</div>
                    <span><div id="wangEditor4_view"></div></span>
                  </el-col>
                  <el-col :span="24">
                    <div style="margin: 15px 0">上线步骤</div>
                    <span>
                      <el-table
                        :data="editForm.onlineDetail.onlineStep"
                        highlight-current-row
                        :default-sort="{ prop: 'date', order: 'descending' }"
                        tooltip-effect="dark"
                      >
                        <el-table-column
                          label="序号"
                          align="left"
                          prop="no"
                          min-width="50px"
                          :show-overflow-tooltip="true"
                        />
                        <el-table-column
                          label="确认动作"
                          align="left"
                          prop="qrdz"
                          min-width="150px"
                          :show-overflow-tooltip="true"
                        />
                        <el-table-column
                          label="上线步骤"
                          align="left"
                          prop="qrbz"
                          min-width="150px"
                          :show-overflow-tooltip="true"
                        />
                        <template slot="empty">
                          <div class="nodata">
                            <img src="@/img/nodata.png" alt="" width="160" />
                            <div>暂无数据</div>
                          </div>
                        </template>
                      </el-table>
                    </span>
                  </el-col>
                  <el-col :span="24">
                    <div style="margin: 15px 0">附件</div>
                    <span>
                      <el-table
                        :data="editForm.onlineDetail.onlineFile"
                        highlight-current-row
                        :default-sort="{ prop: 'date', order: 'descending' }"
                        tooltip-effect="dark"
                      >
                        <el-table-column
                          label="上传人"
                          align="left"
                          prop="xm"
                          min-width="80px"
                          :show-overflow-tooltip="true"
                        />
                        <el-table-column
                          label="文件名称"
                          align="left"
                          prop="name"
                          min-width="200px"
                          :show-overflow-tooltip="true"
                        >
                          <template slot-scope="scope">
                            <el-link
                              @click="openPreview(scope.row)"
                              type="primary"
                              >{{ scope.row.name }}</el-link
                            >
                          </template>
                        </el-table-column>

                        <el-table-column
                          label="操作"
                          align="left"
                          min-width="50px"
                          :show-overflow-tooltip="true"
                        >
                          <template slot-scope="scope">
                            <el-button
                              type="text"
                              @click="handleDownloadFile(scope.row)"
                              >下载</el-button
                            >
                          </template>
                        </el-table-column>
                        <template slot="empty">
                          <div class="nodata">
                            <img src="@/img/nodata.png" alt="" width="160" />
                            <div>暂无数据</div>
                          </div>
                        </template>
                      </el-table>
                    </span>
                  </el-col>
                </el-row>
              </div>
              <div
                v-show="!editForm.onlineDetail.qdqrfzr"
                style="text-align: center"
              >
                <div><img src="@/img/nodata.png" alt="" width="240" /></div>
                <div style="color: #bfbfbf; font-size: 16px">暂无上线记录</div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
    </el-row>
    <div class="bottom-btn">
      <div class="btn-item" @click="btnFlag = !btnFlag">
        <span><img src="../../img/menu_bottom_1.svg" alt="" /></span>
        <span v-text="btnFlag ? '收起' : '展开'"></span>
      </div>
      <span v-show="btnFlag">
        <div class="btn-item" @click="handleClose">
          <span><img src="../../img/menu_bottom_2.svg" alt="" /></span>
          <span>返回</span>
        </div>
        <div class="btn-item">
          <el-popconfirm
            title="确定删除吗？"
            @confirm="handelDel"
            v-if="editForm.control.isdelete == 1"
          >
            <div slot="reference">
              <span><img src="../../img/menu_bottom_12.svg" alt="" /></span>
              <span>删除</span>
            </div>
          </el-popconfirm>
        </div>
        <div
          class="btn-item"
          @click="confirmDialog = true"
          v-if="editForm.control.isconfirm == 1"
        >
          <span><img src="../../img/menu_bottom_5.svg" alt="" /></span>
          <span>确认</span>
        </div>
        <div
          class="btn-item"
          @click="editDialog = true"
          v-if="editForm.control.isedit == 1"
        >
          <span><img src="../../img/menu_bottom_4.svg" alt="" /></span>
          <span>编辑</span>
        </div>
        <div
          class="btn-item"
          @click="solveDialog = true"
          v-if="editForm.control.issolve == 1"
        >
          <span><img src="../../img/menu_bottom_6.svg" alt="" /></span>
          <span>解决</span>
        </div>
        <div
          class="btn-item"
          @click="checkDialog = true"
          v-if="editForm.control.isverifie == 1"
        >
          <span><img src="../../img/menu_bottom_7.svg" alt="" /></span>
          <span>验证</span>
        </div>
        <div
          class="btn-item"
          @click="closeDialog = true"
          v-if="editForm.control.isclose == 1"
        >
          <span
            ><img
              src="../../img/menu_bottom_13.svg"
              alt=""
              style="width: 20px; vertical-align: middle"
          /></span>
          <span>关闭</span>
        </div>
        <div
          class="btn-item"
          @click="startReviewDialog = true"
          v-if="editForm.control.isinitiatereview == 1"
        >
          <span><img src="../../img/menu_bottom_9.svg" alt="" /></span>
          <span>发起评审</span>
        </div>
        <div
          class="btn-item"
          @click="reviewDialog = true"
          v-if="editForm.control.isreview == 1"
        >
          <span><img src="../../img/menu_bottom_10.svg" alt="" /></span>
          <span>评审</span>
        </div>
        <!-- <div
          class="btn-item"
          @click="fqxzDialog = true"
          v-if="editForm.control.isinitiatecollaboration == 1"
        >
          <span><img src="../../img/menu_bottom_14.svg" alt="" /></span>
          <span>发起协作</span>
        </div> -->
        <div class="btn-item" v-if="editForm.control.isonlineconfirmation == 1">
          <span><img src="../../img/menu_bottom_15.svg" alt="" /></span>
          <span>上线确认</span>
        </div>
      </span>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="指派说明"
      :visible.sync="zpsmDialog"
      width="80%"
      v-if="zpsmDialog"
      id="mx-dialog"
      append-to-body
    >
      <div class="comment">
        <div
          class="zpsm-comment-item"
          v-for="(item, index) of editForm.designeeList"
          :key="index"
        >
          <div class="top">
            <div>{{ item.createby[0] }}</div>
            <div>{{ item.createby }}</div>
            <div><img src="@/img/zhipai.svg" alt="" /></div>
            <div>{{ item.designee }}</div>
          </div>
          <div class="middle">
            {{ item.content }}
          </div>
          <div class="bottom">
            {{ item.create_time }}
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="zpsmDialog = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${mxParams.id}  ${mxParams.title}> 编辑`"
      :visible.sync="editDialog"
      width="80%"
      v-if="editDialog"
      id="mx-dialog"
      append-to-body
    >
      <Edit ref="edit" @giveFather="getSon" :mxParams="mxParams"></Edit>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editQuestion()">保存</el-button>
        <el-button type="primary" @click="editQuestion()"
          >重新发起评审</el-button
        >
        <el-button @click="editDialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${mxParams.id}  ${mxParams.title}> 确认`"
      :visible.sync="confirmDialog"
      width="80%"
      v-if="confirmDialog"
      id="mx-dialog"
      append-to-body
    >
      <Confirm
        ref="confirm"
        @giveFather="getSon"
        :mxParams="mxParams"
      ></Confirm>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmQuestion()"
          >保存并指派</el-button
        >
        <el-button @click="confirmDialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${mxParams.id}  ${mxParams.title}> 验证`"
      :visible.sync="checkDialog"
      width="80%"
      v-if="checkDialog"
      id="mx-dialog"
      append-to-body
    >
      <Check ref="check" @giveFather="getSon" :mxParams="mxParams"></Check>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkQuestion()" type="primary">保存</el-button>
        <el-button @click="checkDialog = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${mxParams.id}  ${mxParams.title}> 关闭`"
      :visible.sync="closeDialog"
      width="80%"
      v-if="closeDialog"
      id="mx-dialog"
      append-to-body
    >
      <Close ref="close" @giveFather="getSon" :mxParams="mxParams"></Close>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeQuestion()" type="primary">保存</el-button>
        <el-button @click="closeDialog = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${mxParams.id}  ${mxParams.title}> 解决`"
      :visible.sync="solveDialog"
      width="80%"
      v-if="solveDialog"
      id="mx-dialog"
      append-to-body
    >
      <Solve ref="solve" @giveFather="getSon" :mxParams="mxParams"></Solve>
      <div slot="footer" class="dialog-footer">
        <el-button @click="solveQuestion()" type="primary">保存</el-button>
        <el-button @click="solveDialog = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${mxParams.id}  ${mxParams.title}> 发起协作`"
      :visible.sync="fqxzDialog"
      width="80%"
      v-if="fqxzDialog"
      id="mx-dialog"
      append-to-body
    >
      <FqxzQuestion
        ref="fqxz"
        @giveFather="getSon"
        :mxParams="mxParams"
      ></FqxzQuestion>
      <div slot="footer" class="dialog-footer">
        <el-button @click="fqxzQuestion()" type="primary">保存</el-button>
        <el-button @click="fqxzDialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${mxParams.id}  ${mxParams.title}> 发起评审`"
      :visible.sync="startReviewDialog"
      width="80%"
      top="20px"
      v-if="startReviewDialog"
      append-to-body
    >
      <startReview
        v-if="startReviewDialog"
        :mxParams="mxParams"
        @hideDialog="closeStartReviewDialog"
        @getList="getList"
      ></startReview>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${mxParams.id}  ${mxParams.title}> 评审`"
      :visible.sync="reviewDialog"
      width="80%"
      top="20px"
      v-if="reviewDialog"
      append-to-body
    >
      <updateReview
        v-if="reviewDialog"
        :mxParams="mxParams"
        @hideDialog="closeReviewDialog"
        @getList="getList"
      ></updateReview>
    </el-dialog>
  </el-form>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";
import wangEditor from "wangeditor";

import { getXmxxList } from "@/api/itWeekly";
import {
  deleteQuestion,
  getDictData,
  saveComment,
  viewQuestion,
} from "@/api/question.js";

import { fetchQuestionTx } from "@/api/common.js";

import { cutContent, deepClone, getPicList } from "../../utils/utils";
import startReview from "../question/startReview";
import updateReview from "../question/updateReview";
import Check from "./check.vue";
import Close from "./closeQueastion.vue";
import Confirm from "./confirm.vue";
import Edit from "./edit.vue";
import FqxzQuestion from "./fqxzQuestion.vue";
import Solve from "./solveQueastion.vue";
import ViewQuestion from "./view.vue";
export default {
  components: {
    Treeselect,
    Edit,
    ViewQuestion,
    Confirm,
    Check,
    Close,
    Solve,
    FqxzQuestion,
    startReview,
    updateReview,
  },
  computed: {
    ...mapGetters(["deptUser", "question"]),
  },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      form: {
        rldxActive: 1,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      fileList: [],
      rules: {
        title: [{ required: true, message: "标题不能为空", trigger: "blur" }],
        rwTxlx: [
          {
            required: true,
            message: "任务所属条线不能为空",
            trigger: "change",
          },
        ],
        rwBmbh: [
          {
            required: true,
            message: "帖子所在专栏不能为空",
            trigger: "change",
          },
        ],
        rwName: [
          { required: true, message: "帖子关键词不能为空", trigger: "change" },
        ],
        rwSun: [{ required: true, message: "子类不能为空", trigger: "blur" }],
        // rwsm: [
        //   { required: true, message: "任务说明不能为空", trigger: "blur" },
        // ],
        // content: [{ required: true, message: '帖子内容不能为空', trigger: 'blur' }],
      },
      editForm: {
        line: null,
        xmbh: null,
        productVersion: null,
        title: null,
        sort: null,
        finishTime: null,
        planTime: null,
        designee: null,
        detail: null,
        jjfa: null,
        fileIds: null,
        pinglun: [],
        reviewedDetail: [],
        jdTime: [],
        control: {},
        onlineDetail: {
          onlineFile: [],
          onlineStep: [],
          qdqrfzr: null,
        },
      },

      txList: [],
      xmList: [],
      sortList: [],
      bmList: [],
      statusList: [],
      yzcdList: [],
      rldxList: [
        {
          label: "部门",
          value: 2,
        },
        {
          label: "条线",
          value: 3,
        },
        {
          label: "员工",
          value: 1,
        },
      ],
      data2: {
        type: 2, //说明：类型1 总部-分公司 2分公司-总部
        htlx: "0", //说明：合同类型，多个,隔开，如DS,SW,SD,TS
        range: 0, //说明：数据范围 1-角色数据权限 0-全部
        htzt: "0",
        //htzt: "1,2,3,4,5", //合同状态，多个,隔开，如1,3
      },
      activeEditor: "0",
      activeRight: "0",
      zpsmDialog: false,
      parentDialog: false,
      rFromMoreFlag: false,
      btnFlag: true,
      addDialog: false,
      editDialog: false,
      viewDialog: false,
      confirmDialog: false,
      checkDialog: false,
      closeDialog: false,
      solveDialog: false,
      fqxzDialog: false,
      startReviewDialog: false,
      reviewDialog: false,
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    fetchQuestionTx().then((res) => {
      if (res.code == 0) {
        this.txList = res.data;
      }
    });
    getXmxxList(
      this.data2.htlx,
      this.data2.range,
      this.data2.htzt,
      "",
      ""
    ).then((res) => {
      if (res.code == 0) {
        this.xmList = res.data;
      }
    });
    getDictData("pmp_quality_sort", 1).then((res) => {
      if (res.code === 0) {
        this.sortList = res.data;
      }
    });
    getDictData("pmp_quality_status", 1).then((res) => {
      if (res.code === 0) {
        this.statusList = res.data;
      }
    });
    getDictData("pmp_quality_type", 1).then((res) => {
      if (res.code === 0) {
        this.yzcdList = res.data;
      }
    });
    this.getData();
  },
  mounted() {
    let editor3 = new wangEditor(`#wangEditor3_view`);
    let editor4 = new wangEditor(`#wangEditor4_view`);

    editor3 = this.editorConfig(editor3, true);
    editor4 = this.editorConfig(editor4);
    editor4.disable();
    // 创建编辑器

    this.editor3 = editor3;
    this.editor4 = editor4;

    setTimeout(() => {
      const w = document.querySelector(".bottom-btn").clientWidth;
      document.querySelector(".bottom-btn").style.marginLeft = `${-w / 2}px`;
      document.querySelector(".bottom-btn").style.visibility = `visible`;
      document.querySelector(".bottom-btn").style.left = "50%";
    }, 1000);
  },
  methods: {
    getList() {
      this.$store.dispatch(
        "question/fetchQuestionListAction",
        this.question.questionList.params
      );
    },

    getData(isComment) {
      viewQuestion({ id: this.mxParams.id }).then((res) => {
        if (res.code == 0) {
          if (isComment) {
            this.editForm.pinglun = res.data.pinglun;
          } else {
            const onlineDetail = deepClone(this.editForm.onlineDetail);
            if (!res.data.onlineDetail) {
              this.editForm = { ...res.data, onlineDetail };
            } else {
              this.editForm = res.data;
            }

            /********************************************** */

            const detailPicList = getPicList(this.editForm.detail);
            this.editForm.detailSlice = cutContent(
              detailPicList,
              this.editForm.detail
            );

            const jjfaPicList = getPicList(this.editForm.jjfa);
            this.editForm.jjfaSlice = cutContent(
              jjfaPicList,
              this.editForm.jjfa
            );
            /******************************* */
            const qdqrnr = this.editForm.onlineDetail.qdqrnr
              ? this.editForm.onlineDetail.qdqrnr
              : "";
            this.editor4.txt.html(qdqrnr);
            if (this.editForm.finishTime) {
              this.editForm.finishTime = moment(this.editForm.finishTime + "");
            }
            if (this.editForm.sxsj) {
              this.editForm.sxsj = moment(this.editForm.sxsj + "");
            }
            let temp = this.editForm.reviewedDetail;
            if (temp && temp.length > 0) {
              temp = temp.reverse();
            }
            this.editForm.reviewedDetail = temp;
            if (this.editForm.jdTime && this.editForm.jdTime.length > 0) {
              let jihuo = deepClone(this.editForm.jdTime[0]);
              jihuo.status = "提交";
              this.editForm.jdTime.unshift(jihuo);
            }
            if (!this.editForm.designee) {
              this.editForm.designee = null;
            }
          }
          if (this.editForm.pinglun && this.editForm.pinglun.length > 0) {
            for (let i in this.editForm.pinglun) {
              const picList = getPicList(this.editForm.pinglun[i].content);

              this.editForm.pinglun[i].commnetSlice = cutContent(
                picList,
                this.editForm.pinglun[i].content
              );
            }
          }
          console.log(this.editForm.pinglun);
        }
      });
    },
    editorConfig(editor, needMenu) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = 300;
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      editor.config.uploadImgServer = window.g.apiUrl + "/system/uploadPicFile";
      editor.config.uploadImgHeaders = {
        "x-token": localStorage.getItem("token"), // 设置请求头
      };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      if (needMenu) {
        editor.config.excludeMenus = ["video", "link", "code"];
      } else {
        editor.config.excludeMenus = [
          "head",
          "bold",
          "fontSize",
          "fontName",
          "italic",
          "underline",
          "strikeThrough",
          "indent",
          "lineHeight",
          "foreColor",
          "backColor",
          "link",
          "list",
          "todo",
          "justify",
          "quote",
          "emoticon",
          "image",
          "video",
          "table",
          "code",
          "splitLine",
          "undo",
          "redo",
        ];
      }
      // 配置 onchange 回调函数，将数据同步到 vue 中
      // editor.config.onchange = function () {
      //   if (editor.txt.html() == "") {
      //     editor.txt.html("&nbsp");
      //   }
      // };

      editor.create();
      return editor;
    },

    resetFrom() {
      this.editForm = {
        ...this.editForm,
        ...{
          jf: null,
          title: null,
          rldx: 1,
          ygbhs: null,
          bmbhs: null,
          txlxs: null,
          rwsm: null,
          yqjg: null,
          jsrq: null,
          gs: 0,
          rwmb: null,
          bz: null,
        },
      };
      this.editor.txt.html("");
      this.editor2.txt.html("");
      this.form.rldxActive = 0;
    },
    handleChange(file, fileList) {
      //验证上传文件的格式
      // const suffixReg = /(xls|xlsx|pdf|doc|docx|ppt|pptx)$/;
      // const point = file.name.lastIndexOf(".");
      // const suffix = file.name.substr(point + 1);
      // const isFile = suffixReg.test(suffix);
      // if (!isFile) {
      //   this.$message.error("请上传正确格式的文件 !");
      //   fileList.pop();
      //   return false;
      // }
      // 验证文件大小
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error(file.name + "文件大小超出限制，请修改后重新上传");
        return false;
      }
      //验证上传文件重复
      // let existFile = fileList
      //   .slice(0, fileList.length - 1)
      //   .find((f) => f.name === file.name);
      // if (existFile) {
      //   this.$message.error("当前文件已经存在!");
      //   fileList.pop();
      //   return false;
      // }
    },
    handleExceed(files, fileList) {
      this.$message.error(
        `当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    submitUpload() {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          this.$refs.upload.submit();
          let { uploadFiles } = this.$refs.upload;
          let fileLen = uploadFiles.length;
          let form = new FormData();
          uploadFiles.forEach((item, index) => {
            form.append("files", item.raw);
          });

          if (fileLen > 0) {
            //上传文件
            return new Promise((resolve, reject) => {
              uploadFile(form)
                .then((res) => {
                  if (res.code == 0) {
                    this.$message.success("上传成功！");
                  } else {
                    this.$message({
                      type: "error",
                      message: res.msg,
                      showClose: true,
                    });
                  }
                  resolve(res);
                })
                .catch((err) => {
                  reject(err);
                });
            }).then((success) => {});
          } else if (fileLen == 0) {
          } else {
            this.$message.error(res.msg);
            return false;
          }
        } else {
          this.hiddenDialog(true);
        }
      });
    },
    handleAddComment() {
      const params = {
        id: this.mxParams.id,
        status: this.editForm.status,
        content: this.editor3.txt.html(),
      };
      if (!params.content) {
        return;
      }
      saveComment(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.editor3.txt.html("");
          this.getData(true);
        }
      });
    },
    handleDownloadFile(row) {
      const filePath = row.url;
      const fileName = row.name;
      const url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },

    giveFather() {
      this.parentDialog = false;
    },
    openPreview(row) {
      const url = row.previewurl;
      window.open(url);
    },
    handleClickTabs(e) {
      this.activeEditor = e.index;
    },
    handleClickTabsRight(e) {
      this.activeRight = e.index;
    },
    handelDel() {
      deleteQuestion({ id: this.mxParams.id }).then((res) => {
        if (res.code == 0) {
          this.$store.dispatch(
            "question/fetchQuestionListAction",
            this.question.questionList.params
          );
          this.handleClose();
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 底部按钮事件
    handleClose() {
      this.$emit("giveFather", this.parentDialog);
    },

    editQuestion() {
      this.$refs.edit.submitUpload();
    },
    confirmQuestion() {
      this.$refs.confirm.submitUpload();
    },
    checkQuestion() {
      this.$refs.check.saveForm();
    },
    closeQuestion() {
      this.$refs.close.saveForm();
    },
    solveQuestion() {
      this.$refs.solve.submitUpload();
    },
    fqxzQuestion() {
      this.$refs.fqxz.saveForm();
    },
    getSon() {
      this.addDialog = false;
      this.editDialog = false;
      this.viewDialog = false;
      this.confirmDialog = false;
      this.checkDialog = false;
      this.closeDialog = false;
      this.solveDialog = false;
      this.fqxzDialog = false;
      this.getData();
    },
  },
};
</script>
<style lang="less" scoped>
.star {
  position: absolute;
  top: 13px;
  color: #f56c6c;
  left: 40px;
}
.r {
  margin: 0 10px;
  .r_title {
    text-align: center;
    line-height: 40px;
    border-bottom: 2px solid #e4e7ed;
    box-sizing: border-box;
    height: 40px;
    margin-bottom: 15px;
  }
}
.zpsm-comment-item {
  margin-top: 15px;
}
.top {
  display: flex;
  line-height: 30px;
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 10px;
  > div {
    margin-right: 15px;
  }
  > div:nth-of-type(1) {
    background-color: #8080ff;
    color: #fff;
    height: 30px;
    line-height: 30px;
    width: 30px;
    text-align: center;
    border-radius: 50%;
  }
}
.middle {
  line-height: 40px;
  color: #555;
  padding-left: 15px;
  min-height: 40px;
}
.bottom {
  font-size: 12px;
  color: #7f7f7f;
  margin-bottom: 15px;
}
.r_more_btn {
  line-height: 40px;
  text-align: center;
  margin-left: 100px;
  cursor: pointer;
  color: #888;
}
.r_review {
  .tips {
    background-color: #d7d7d7;
    height: 44px;
    line-height: 44px;
    padding: 0 15px;
    margin: 15px 0;
  }
  .middle {
    padding-right: 50px;
  }
  .r_review_item {
    position: relative;
  }
  .r_review_status {
    position: absolute;
    top: 30px;
    right: 0px;

    img {
      width: 40px;
    }
  }
}

.bottom-btn {
  position: fixed;
  visibility: hidden;
  bottom: 70px;
  display: flex;
  background-color: #717171;
  color: #fff;
  height: 44px;
  line-height: 44px;
  z-index: 100005;
  border-radius: 10px;
  > span {
    display: flex;
    height: 44px;
    line-height: 44px;
  }
  .btn-item {
    padding: 0 8px;
    display: flex;
    justify-items: center;
    cursor: pointer;
    span:nth-of-type(1) {
      margin-right: 10px;
    }
    img {
      vertical-align: text-bottom;
      width: 16px;
    }
  }
}
.content_view {
  height: 300px;
  overflow: auto;
  border: 1px solid #ddd;
  padding: 15px;
  box-sizing: border-box;
}
</style>